export interface IRemoteDonationPreferred {
    id: number,
    firstName: string,
    lastName: string,
    city: string,
    state: string,
    postalCode: string,
    entryDomain: string,
    recipientCenter: string,
    center: string,
    currentRegistrationStep: string,
    preWorkupLabStrep: string
}